/*
 *
 * TutorialPopup
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 10-Sep-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  stepTutorialSkip: (
    <PortalMessage
      id='t.app.tutorial.step.skip'
      defaultMessage='Salta'
    />
  ),
  stepTutorialNext: (
    <PortalMessage
      id='t.app.tutorial.step.next'
      defaultMessage='Avanti'
    />
  ),
  stepTutorialGoHome: (
    <PortalMessage
      id='t.app.goHome'
      defaultMessage='Vai in home'
    />
  ),
  stepTutorialPrev: (
    <PortalMessage
      id='t.app.back'
      defaultMessage='Indietro'
    />
  ),
  tutorialTitleHomepage: (
    <PortalMessage
      id='t.app.tutorial.title.homepage'
      defaultMessage='Tieni tutti i tuoi dati sotto controllo nella homepage'
    />
  ),
  tutorialTitleTransactions: (
    <PortalMessage
      id='t.app.tutorial.title.transactions'
      defaultMessage='Visualizza e filtra <br/> le tue transazioni"'
    />
  ),
  tutorialTitleResults: (
    <PortalMessage
      id='t.app.tutorial.title.results'
      defaultMessage='Monitora e confronta <br/> i risultati della tua attività'
    />
  ),
  tutorialTitleDocuments: (
    <PortalMessage
      id='t.app.tutorial.title.documents'
      defaultMessage='Consulta e scarica <br/> gli estratti conto e tutti <br/> gli altri documenti'
    />
  ),
  tutorialTitleMenu: (
    <PortalMessage
      id='t.app.tutorial.title.menu'
      defaultMessage='Scopri i servizi aggiuntivi, <br/> gli incassi e le commissioni <br/> nel menù'
    />
  ),
  // Only for Nexi Direct ISP
  tutorialTitleMenuNexiDirectISP: (
    <PortalMessage
      id='t.app.tutorial.title.menu.nexiDirectISP'
      defaultMessage='Scopri i servizi aggiuntivi <br/> e le commissioni nel menù'
    />
  ),
  tutorialTitleProfile: (
    <PortalMessage
      id='t.app.tutorial.title.profile'
      defaultMessage='Accedi al profilo per gestire <br/> i dati della società, dei punti vendita e le comunicazioni'
    />
  )
}

export default formattedMessage
